/*
 * @Date: 2021-01-24 16:45:28
 * @LastEditors: jiangqian
 * @LastEditTime: 2020-01-26 16:45:28
 */
const vaildParams = (params, configParams, logs = {}) => {
    let logParams = params;
    if (logParams) {
        // 如果不是对象提示错误信息
        if (typeof logParams != 'object') {
            console.error('参数配置应传对象');
        }
        else {
            //  验证展现日志参数是否在公共参数里面
            for (let i in logParams) {
                const type = typeof logParams[i];
                // 已定义参数，判断类型
                if (configParams[i]) {
                    const configType = configParams[i].type.toLowerCase();
                    if (type !== configType) {
                        // 尝试转格式
                        if (configType === 'number') {
                            logParams[i] = Number(logParams[i]) || 0;
                        }
                        else if (configType === 'string' && type === 'number') {
                            logParams[i] = String(logParams[i]);
                        }
                        console.error(`打点参数${i}的类型应为：${configType}`);
                    }
                }
                else {
                    // 不存在打点转string放行
                    if (type !== 'object' ||
                        (type === 'object' && logParams[i] instanceof Array)) {
                        logParams[i] = String(logParams[i]);
                    }
                    console.error(`eventid: ${logs.eventid}中不存在打点参数${i}`);
                }
            }
        }
    }
    return logParams;
};
// click参数验证和合并
const vaildClickParams = (params, clickObj = {}, logs = {}) => {
    console.log('上报的参数', Object.assign({}, params));
    let logParams = Object.assign({}, params);
    if (logParams) {
        // 如果不是对象提示错误信息
        if (typeof logParams !== 'object') {
            console.error('参数配置应传对象');
        }
        else {
            let clickid = logParams.clickid;
            let clickItem = clickObj[clickid];
            if (clickid && clickItem) {
                // 在配置中，开始校验类型和参数
                // 先校验clickid
                const type = typeof clickid;
                const configType = clickItem.type.toLowerCase();
                if (type !== configType) {
                    // 尝试转格式
                    if (configType === 'number') {
                        logParams.clickid = Number(logParams.clickid) || 0;
                    }
                    else if (configType === 'string' && type === 'number') {
                        logParams.clickid = String(logParams.clickid);
                    }
                    console.warn(`打点参数clickid的类型应为：${configType}`);
                }
                let otherParams = Object.assign({}, params);
                delete otherParams.clickid;
                // 校验其他参数
                otherParams = vaildParams(otherParams, clickItem.others, logs);
                // 合并参数
                Object.assign(logParams, { action: clickItem.action, elemname: clickItem.elemname }, clickItem.othersVal, otherParams);
                console.log('合并参数', logParams);
            }
            else {
                // 不在配置中
                console.warn(`未配置日志参数交互日志${clickid}`);
            }
        }
    }
    return logParams;
};
// 日志id 是否合法
const isValidObjectId = (str) => {
    const checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');
    return checkForHexRegExp.test(str);
};
// 日志参数初始化
const initLogsData = (logs = {}) => {
    let logOptions = {
        common: {
            eventid: logs.eventid
        },
        loadMsg: {
            open: false
        },
        hashchange: {
            open: false
        },
        param: {},
        appid: {
            'localhost': {
                appid: '1001128',
            },
            'activity.xueersi.com': {
                appid: '1001132'
            },
            'huodong.xueersi.com': {
                appid: '1001961',
                appkey: '8a1fb3304fff3af30aa08b4bc3c3f1a1'
            },
            'm.xueersi.com': {
                appid: '1001977',
                appkey: 'e5dfbfaf4f65f27072224c0e34491f89'
            },
            'z.xueersi.com': {
                appid: '1002147',
                appkey: 'a6f7dc25365ba352413de883858c5136'
            },
            'h5.xesv5.com': {
                appid: '1001564',
                appkey: 'f06adda872621d6964158d494316ff9c'
            },
            'h5.xueersi.com': {
                appid: '1001970',
                appkey: 'bb44dee00f385994078571e79202f526'
            }
        }
    };
    let commonParams = {};
    logs.commonParams.forEach((item) => {
        commonParams[item.key] = item;
        logOptions.param[item.key] = item.val;
    });
    let clickObj = {};
    logs.clickList.forEach((item) => {
        let clickItem = {
            clickid: item.clickid,
            action: item.action,
            type: item.type,
            el: item.elemname,
            others: {},
            othersVal: {}
        };
        (item.others || []).forEach((other) => {
            clickItem.others[other.key] = other;
            clickItem.othersVal[other.key] = other.val;
        });
        clickObj[item.clickid] = clickItem;
    });
    return { logOptions, commonParams, clickObj };
};
let XesLoggerAdmin = function (options, Vue) {
    let xesLogger;
    let XesLoggerSDK;
    if (typeof window != 'undefined') {
        XesLoggerSDK = require('@xes/xes_fe_log');
    }
    else {
        XesLoggerSDK = require('@xes/xes_fe_log_miniprogram').default;
    }
    try {
        if (options && isValidObjectId(options)) {
            const logs = require(`@xes/logfile-webpack-plugin/dist/logfiles/${options}.json`);
            console.log('logs=====', logs);
            const { logOptions, commonParams, clickObj } = initLogsData(logs);
            if (typeof window != 'undefined') {
                xesLogger = new XesLoggerSDK(logOptions, Vue);
            }
            else {
                xesLogger = new XesLoggerSDK(logOptions);
            }
            const clickMsg = xesLogger.clickMsg;
            const loadMsg = xesLogger.loadMsg;
            // 重写日志埋点
            // 校验埋点参数是否存在，类型是否正确，添加公共日志参数，公共日志参数是否重复
            xesLogger.loadMsg = async (params) => {
                let logParams = params;
                // 展现日志是否需要单独提出来配置，还是取日志的公共参数
                try {
                    logParams = vaildClickParams(logParams, clickObj, logs);
                    await loadMsg(logParams);
                }
                catch (error) {
                    console.error(`展现日志打点错误,错误信息：${error}`);
                    await loadMsg(logParams);
                }
            };
            // 交互日志
            xesLogger.clickMsg = async (rq) => {
                let logParams = {
                    ...rq.params
                };
                try {
                    logParams = vaildClickParams(logParams, clickObj, logs);
                    const clickParams = Object.assign({}, rq, {
                        params: logParams
                    });
                    if (typeof window != 'undefined') {
                        await clickMsg(clickParams);
                    }
                    else {
                        await clickMsg(logParams);
                    }
                }
                catch (error) {
                    console.error(`交互日志打点错误,错误信息：${error}`);
                    if (typeof window != 'undefined') {
                        await clickMsg(rq);
                    }
                    else {
                        await clickMsg(rq.params);
                    }
                }
                // console.log('logParams', logParams)
            };
            // 设置公共日志参数
            xesLogger.setCommonParam = (params) => {
                // 校验公共日志参数
                const logParams = vaildParams(params, commonParams, logs);
                Object.assign(logOptions.param, logParams || {});
            };
        }
        else {
            throw Error('日志文档id缺失或不正确');
        }
    }
    catch (error) {
        const logOptions = {
            common: {
                eventid: 'other-logs'
            },
            loadMsg: {
                open: false
            },
            hashchange: {
                open: false
            },
            param: {}
        };
        if (typeof window != 'undefined') {
            xesLogger = new XesLoggerSDK(logOptions, Vue);
        }
        else {
            xesLogger = new XesLoggerSDK(logOptions);
        }
        const clickMsg = xesLogger.clickMsg;
        xesLogger.setCommonParam = (params) => {
            Object.assign(logOptions.param, params || {});
        };
        xesLogger.clickMsg = async (rq) => {
            if (typeof window != 'undefined') {
                await clickMsg(rq);
            }
            else { // 小程序上报的时候没有params;
                await clickMsg(rq.params);
            }
        };
        if (options && isValidObjectId(options)) {
            console.error(`日志文档不存在，请检查日志id: ${options}`);
        }
        else {
            console.error('日志文档id缺失或不正确');
        }
    }
    this.xesLogger = xesLogger;
};
XesLoggerAdmin.prototype = {
    constructor: XesLoggerAdmin
};
XesLoggerAdmin.prototype.setCommonParam = function (params) {
    this.xesLogger.setCommonParam(params);
};
XesLoggerAdmin.prototype.loadMsg = async function (params) {
    await this.xesLogger.loadMsg(params);
};
XesLoggerAdmin.prototype.clickMsg = async function (params) {
    await this.xesLogger.clickMsg(params);
};
XesLoggerAdmin.install = async function vuePluginInstall(Vue, options) {
    let xesLogger;
    if (!Vue.prototype.$xesLogger) {
        xesLogger = new XesLoggerAdmin(options, Vue);
        Vue.prototype.$xesLogger = xesLogger;
    }
};

export default XesLoggerAdmin;
